// import { TRUE } from 'sass'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => localStorage.getItem(key),
        setItem: (key, value) => localStorage.setItem(key, value),
        removeItem: key => localStorage.removeItem(key)
      }
    })
  ],
  //while defining new states, add them to the CLEAR_ALL_STATES mutation as well
  state: {

    campaignPaginationStates: {},
    questionForEdit: {},
    assessmentData: {},
    bulkQuestionRes: [],
    levelChart: null,
    assesedChart:[],
    clusterChart: [],
    chartSearch: "",
    role: {},
    updateRole: null,
    userInfo: {
      name: "user",
      email: "dummyemail@gmail.com",
      id:"",
    },
    school:"Vibgyor Roots - PANATHUR",
    cluster:"Cluster 4",
    isNavBar:false,
    mobileNavDrawerOpen:false,
    user: null,
    userType:localStorage.getItem('userType') || null,
    breadcrumb:"",
    selectedVideo: {},
    currentCraouselIndex: 0,
    userRoleId: '',
    stages: [],
    schoolNames: [],
    groupName:[],
    schools: [],
    groups: [],
    firstFullPath: localStorage.getItem('firstFullPath') || '', 
  },

  getters: {
    getRoleFromStore: state => state.role,
    currentCraouselIndex: state => state.currentCraouselIndex,
    getRoleId: state => state.userRoleId,
    getQuestionForEdit: state =>state.questionForEdit,
    getAssessmentData: state =>state.assessmentData,
    getStages: state => state.stages,
    getSchoolNames: state => state.schoolNames,
    getSchools: state => state.schools,
    getGroupName: state => state.groupName,
    getGroups: state => state.groups,
  },
  mutations: {
    SET_STAGES(state, stages){
      state.stages = stages
    },
    SET_QUESTION_FOR_EDIT(state, questionForEdit){
      state.questionForEdit = questionForEdit;
    },
    SET_ASSESSMENT_DATA(state, assessmentData){
      state.assessmentData = assessmentData;
    },
    SET_PAGINATION_STATE(state, { campaignId, paginationState }) {
      Vue.set(state.campaignPaginationStates, campaignId, paginationState)
    },
    CLEAR_PAGINATION_STATES(state) {
      state.campaignPaginationStates = {}
    },
    SET_ROLE(state, role){
      state.role = role
    },
  
    SET_ROLE_ID(state, roleId){
      state.userRoleId = roleId
    },
    SET_CURRENT_CRAOUSEL_INDEX(state, index) {
      state.currentCraouselIndex = index;
    },
    setChartSearch(state, value) {
      state.chartSearch = value;
    },
    setVideoDetails(state, payload){
      state.selectedVideo = payload
    },
    setUserType(state, type) {
      state.userType = type;
      localStorage.setItem('userType', type);
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_MOBILE_NAV_DRAWER_OPEN(state, isOpen) {
      state.mobileNavDrawerOpen = isOpen;
    },
    CLEAR_ALL_STATES(state) {
      state.campaignPaginationStates= {};
      state.questionForEdit= {};
      state.assessmentData= {};
      state.bulkQuestionRes= [];
      state.levelChart= null;
      state.assesedChart=[];
      state.clusterChart= [];
      state.chartSearch= "";
      state.role= {};
      state.updateRole= null;
      state.userInfo.name= "user";
      state.userInfo.email= "dummyemail@gmail.com";
      state.userInfo.id = ""
      state.school="Vibgyor Roots - PANATHUR";
      state.cluster="Cluster 4";
      state.isNavBar=false;
      state.mobileNavDrawerOpen=false;
      state.user= null;
      state.userType=localStorage.getItem('userType') || null;
      state.breadcrumb="";
      state.selectedVideo= {};
      state.currentCraouselIndex= 0;
      state.userRoleId= '';
      state.firstFullPath='';
      state.schools='';
      state.schoolNames='';
      state.groupName = '';
      state.groups = '';
    },
    setSchoolNames(state, names) {
      state.schoolNames = names;
    },
    clearSchoolNames(state) {
      state.schoolNames = [];
    },
    setSchools(state, names) {
      state.schools = names;
    },
    clearSchools(state) {
      state.schools = [];
    },
    setGroupNames(state, names) {
      state.groupName = names;
    },
    clearGroupNames(state) {
      state.groupName = [];
    },
    setGroups(state, names) {
      state.groups = names;
    },
    clearGroups(state) {
      state.groups = [];
    },
    setFirstFullPath(state, path) {
    if (!state.firstFullPath) {   // only set if empty
      state.firstFullPath = path;
      localStorage.setItem('firstFullPath', path);
    }
    },
    // other mutations...
  },
  actions: {
    setStages({commit}, stages){
      commit('SET_STAGES',stages)
    },
    setQuestionForEdit({commit}, questionForEdit){
      commit('SET_QUESTION_FOR_EDIT', questionForEdit);
    },
    setAssessmentData({commit}, assessmentData){
      commit('SET_ASSESSMENT_DATA', assessmentData);
    },
    savePaginationState({ commit }, { campaignId, paginationState }) {
      commit('SET_PAGINATION_STATE', { campaignId, paginationState })
    },
    clearPaginationStates({ commit }) {
      commit('CLEAR_PAGINATION_STATES')
    },
    setCurrentCraouselIndex({ commit }, index) {
      commit('SET_CURRENT_CRAOUSEL_INDEX', index);
    },
    saveUserType({ commit }, type) {
      commit('setUserType', type);
    },
    setRole({commit}, role){
      commit('SET_ROLE', role)
    },
    setUserInfo({commit}, userInfo){
      commit('SET_USER_INFO', userInfo)
    },
    setRoleId({commit}, roleId){
      commit('SET_ROLE_ID', roleId)
    },
    clearAllStates({commit}){
      commit('CLEAR_ALL_STATES')
    },
  },
  modules: {
  }
})
